import { Link } from 'react-router-dom';

function NotFoundPage({ authenticated = false }) {
  return (
    <div className="page page-shell page-stack">
      <section className="card">
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p>We couldn&apos;t find a page at this address. Check the URL and try again.</p>
        <p>
          <Link to={authenticated ? '/dashboard' : '/login'} className="btn btn-primary">
            {authenticated ? 'Go to dashboard' : 'Go to login'}
          </Link>
        </p>
      </section>
    </div>
  );
}

export default NotFoundPage;
